import { ActivityCollectionHalSource, ActivityCollectionHalSourceProps, ProjectCollectionHalSource, ProjectCollectionHalSourceProps, ProjectHalSource, ProjectHalSourceProps } from "@/halSources";
import request from "../request";

export const getProjects = async (params?: any) => {
  const result = await request.get<any, ProjectCollectionHalSourceProps>('/workbenchApi/api/v3/projects', {
    params,
  });
  return new ProjectCollectionHalSource(result);
};

export const getProject = async (id: number) => {
  const result = await request.get<any, ProjectHalSourceProps>(`/workbenchApi/api/v3/projects/${id}`);
  return new ProjectHalSource(result);
};

export const updateProject = async (id: number, params: any) => {
  const result = await request.patch<any, ProjectHalSourceProps>(`/workbenchApi/api/v3/projects/${id}`, params);
  return new ProjectHalSource(result);
};

export type GetProjectProfileByCodeResult = {
  id: number;
  code: string;
  name: string;
  projectId?: number;
  projectName?: string;
}

export const getProjectProfileByCode = async (code: string) => {
  const result = await request.get<any, GetProjectProfileByCodeResult>(`/workbenchApi/api/v3/project_profiles/${code}`);
  return {
    id: result.id,
    code: result.code,
    name: result.name,
    projectId: result.projectId,
    projectName: result.projectName,
  };
};

export type CopyProjectParams = {
  projectCode?: string;
  projectName: string;
  projectTypeId: number;
  docLink?: string;
};

export type CopyProjectResult = {
  jobId: string;
};

export const copyProject = async (params: CopyProjectParams) => {
  const result = await request.post<any, CopyProjectResult>('/workbenchApi/op/projects', params);
  return result.jobId;
};

export type GetCopyProjectStatusResult = {
  status: string;
  payload?: { redirect: string; }
};

export const getCopyProjectStatus = async (jobId: string) => {
  const result = await request.get<any, GetCopyProjectStatusResult>(`/workbenchApi/op/job_statuses/${jobId}`);
  return {
    success: result.status === 'success',
    redirect: result.payload?.redirect,
  };
};

export type GetProjectActivitiesParams = {
  from_date?: string;
  to_date?: string;
};

export const getProjectActivities = async (id: number | string, params: GetProjectActivitiesParams) => {
  const result = await request.get<any, ActivityCollectionHalSourceProps>(`/workbenchApi/api/v3/projects/${id}/activities`, {
    params,
  });
  return new ActivityCollectionHalSource(result);
};

/**
 * 获取工作包活动
 * @param id 工作包ID
 * @returns
 */
export function getWorkPackageActivitiesAPI(id: number | string): Promise<Op.OpListResult<Op.WorkPackageActivity>> {
  return request.get(`/workbenchApi/api/v3/work_packages/${id}/activities?filter=only_comments`);
}
/**
 * 修改工作包数据
 * @param id 工作包ID
 * @returns
 */
export function patchWorkPackageAPI(id: number | string, data: Op.WorkPackageBody): Promise<Op.WorkPackageInfo> {
  return request.patch(`/workbenchApi/api/v3/work_packages/${id}`, data);
}
/**
 * 回复工作包活动
 * @param id 工作包ID
 * @returns
 */
export function postWorkPackageMsgAPI(id: number | string, data: Op.WorkPackageActivityBody): Promise<Op.WorkPackageActivity> {
  return request.post(`/workbenchApi/api/v3/work_packages/${id}/activities`, data);
}

/**
 * 获取工作包详情
 * @param id 工作包ID
 * @returns
 */
export function getWorkPackageInfoAPI(id: number | string): Promise<Op.WorkPackageInfo> {
  return request.get(`/workbenchApi/api/v3/work_packages/${id}`);
}

export function getPlmUserInfoAPI(id: number | string): Promise<Op.User> {
  return request.get(`/workbenchApi/api/v3/users/${id}`);
}

/**
 * 上传图片
 * @param wpID 工作包ID
 * @returns
 */
export function uploadPlmFileAPI(wpID: string | number, data: FormData): Promise<Op.AttachmentImage> {
  return request.post(`/workbenchApi/api/v3/work_packages/${wpID}/attachments`, data);
}

/**
 * 删除工作包
 * @param wpID 工作包ID
 * @returns
 */
export function deletePlmWorkpackageAPI(wpID: string | number): Promise<Op.AttachmentImage> {
  return request.delete(`/workbenchApi/api/v3/work_packages/${wpID}`);
}

/**
 * 更新工作包状态
 * @param wpID 工作包ID
 * @returns
 */
export function updatePlmPackageStatusAPI(wpID: string | number, statusID: number, lockVersion: number): Promise<Op.AttachmentImage> {
  const data = {
    "lockVersion": lockVersion,
    "_links": {
      "status": {
        "href": `/api/v3/statuses/${statusID}`
      }
    }
  }
  return request.patch(`/workbenchApi/api/v3/work_packages/${wpID}`, data);
}